import { AgGridReact } from "ag-grid-react";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, Group } from "@mantine/core";
import { IDeviceCategoryEnum } from "@backend/src/shared/schemas/foundationSchema";
import DeviceIcon from "../../SelectedSpace/DeviceIcon";
import { IMcBimItemWithExtraFrontendInfo } from "../../types/types";
import { useAppSelector } from "../../app/hooks";
import { selectCompCodePath } from "../../globalSelectors";
import { getDeeplyNestedValue } from "@multiconsult-group/multiplacer-core";

const StandardRoomItemsTable: React.FC<{
  items: IMcBimItemWithExtraFrontendInfo[];
}> = ({ items }) => {
  const compCodePath = useAppSelector(selectCompCodePath);

  const columns: ColDef<IMcBimItemWithExtraFrontendInfo>[] = [
    {
      field: "_id",
      hide: true,
    },
    {
      field: "deviceCategory",
      hide: true,
      sort: "desc",
    },
    {
      colId: "compCode",
      headerName: "Artikkelnr",
      width: 150,
      valueGetter: (params) =>
        compCodePath ? getDeeplyNestedValue(params.data, compCodePath) ?? "-" : "-",
      cellRenderer: (params: ICellRendererParams<IMcBimItemWithExtraFrontendInfo>) => {
        return (
          <Group gap="xs" wrap="nowrap">
            <DeviceIcon deviceType={params.data?.deviceCategory as IDeviceCategoryEnum} />
            <span>{params.value ?? "-"}</span>
          </Group>
        );
      },
    },
    {
      colId: "typeName",
      headerName: "Beskrivelse",
      flex: 1,
      valueGetter: (params) => params.data?.type?.name ?? "-",
    },
  ];

  return (
    <Box h="100%" style={{ minHeight: 0, display: "flex", flex: 1, overflow: "auto" }}>
      <div
        className="ag-theme-quartz"
        style={{
          width: "100%",
          minHeight: 0,
          flex: 1,
        }}
      >
        <AgGridReact
          domLayout="autoHeight"
          columnDefs={columns}
          rowData={items}
          getRowId={(params) => params.data._id}
        />
      </div>
    </Box>
  );
};

export default StandardRoomItemsTable;
